<template>
    <div class="body">
        <div class="title">
            发布
            <!-- 面包屑导航区域 -->
            <div class="fansk">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf"> 首页 </span></el-breadcrumb-item>
                    <el-breadcrumb-item>赛事管理</el-breadcrumb-item>
                    <el-breadcrumb-item>
                        <span class="dsadf"> 发布 </span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <div style="margin: -20px 0 20px">
            <el-button size="mini" @click="$router.back()">返回</el-button>
        </div>

        <el-card>
            <el-form ref="form" :model="addQuery" :rules="rules" label-width="120px" :label-position="labelPosition" @submit.native.prevent>
                <!-- <el-form-item label="发布者名称" label-width="13%">
                    <el-input v-model="addQuery.user_name" style="width: 294px" placeholder="请输入发布者名称"></el-input>
                </el-form-item>
                <el-form-item label="logo" label-width="13%">
                    <div class="imgbox" v-if="addQuery.user_logo !== ''">
                        <img :src="addQuery.user_logo" alt="" class="imgs" />
                        <img src="../../assets/img/shanchu.png" mode="" class="close" @click="closeuserLogo" v-if="addQuery.user_logo !== ''" />
                    </div>
                    <el-upload v-if="addQuery.user_logo === ''" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarSuccessLogo" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item> -->
                <el-form-item label="赛事标题" prop="name" label-width="13%">
                    <el-input v-model="addQuery.name" style="width: 294px" placeholder="请输入赛事标题"></el-input>
                </el-form-item>

                <el-form-item label="赛事类型" prop="space" label-width="13%">
                    <el-select style="width: 300px" v-model="addQuery.space" placeholder="选择赛事类型">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>

                <el-form-item label="赛事分组" prop="act_group_ids" label-width="13%">
                    <el-input v-model="activeGroupForm.name" size="small" placeholder="组名" style="width: 150px; margin-right: 10px">
                    </el-input>
                    <el-input v-model="activeGroupForm.number" size="small" placeholder="人数" style="width: 80px; margin-right: 10px">
                    </el-input>
                    <el-input v-model="activeGroupForm.age" size="small" placeholder="年龄" style="width: 80px; margin-right: 10px">
                    </el-input>
                    <el-input v-model="activeGroupForm.sex" size="small" placeholder="性别" style="width: 80px; margin-right: 10px">
                    </el-input>
                    <!-- <el-select v-model="activeGroupForm.sex" size="small" placeholder="性别" style="width: 100px; margin-right: 10px">
                        <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select> -->
                    <el-button size="small" @click="addGroup" style="width: 80px">添加</el-button>
                    <div>
                        <el-tag :key="tag.id" v-for="(tag, index) in activeGroup" closable :disable-transitions="false" style="margin: 10px 10px 0 0" @close="deleteGroup(tag, index)">
                            {{ tag.title }}
                        </el-tag>
                    </div>
                </el-form-item>

                <el-form-item label="宣传图片" prop="pics" label-width="13%">
                    <div class="from">
                        <div class="imgbox" v-for="(item, index) in addQuery.pics" :key="index">
                            <img :src="item.name" alt="" class="imgs" />
                            <img src="../../assets/img/shanchu.png" mode="" class="close" @click="closeImgs(index)" v-if="item" />
                        </div>
                    </div>
                    <el-upload v-if="addQuery.pics.length !== 9" class="upload-demo" ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarSuccess" :limit="9" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">选择</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="赛事介绍" prop="introduce" label-width="13%">
                    <quill-editor class="appwrapper" v-model="addQuery.introduce" :rows="3" ref="myQuillEditor" :options="editorOption" style="width: 50%">
                    </quill-editor>
                </el-form-item>

                <el-form-item label="报名时间" prop="enroll_starttime" label-width="13%">
                    <el-date-picker v-model="enrolltime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" @change="changeEnrolltime">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="赛事时间" prop="act_starttime" label-width="13%">
                    <el-date-picker v-model="acttime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" @change="changeActtime">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="赛事地址" prop="area_id" label-width="13%">
                    <el-cascader :props="checkedData.typeOptions" @change="changList"></el-cascader>
                </el-form-item>
                <el-form-item label="" prop="address" label-width="13%">
                    <el-input v-model="addQuery.address" style="width: 300px" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="" prop="longitude" label-width="13%">
                    <el-row style="margin-bottom: 10px">
                        <vxe-button size="medium" content="获取赛事位置经纬度" status="primary" @click="GetJWD('address')"></vxe-button>
                    </el-row>
                    <el-row style="margin-bottom: 10px">
                        <el-input v-model="addQuery.longitude" style="width: 300px" placeholder="请选择经度" disabled></el-input>
                    </el-row>
                    <el-row>
                        <el-input v-model="addQuery.latitude" style="width: 300px" placeholder="请选择纬度" disabled></el-input>
                    </el-row>
                </el-form-item>

                <!-- 签到 -->
                <el-form-item label="是否需要签到" label-width="13%">
                    <el-switch v-model="isSignin" active-text="是" inactive-text="否">
                    </el-switch>
                </el-form-item>

                <template v-if="isSignin">
                    <el-form-item label="签到方式" prop="signin_type" label-width="13%">
                        <el-select v-model="addQuery.signin_type" multiple placeholder="请选择" style="width: 300px">
                            <el-option v-for="item in signInList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="签到时间" prop="signin_starttime" label-width="13%">
                        <el-date-picker v-model="signintime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:00" @change="changeSignintime">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到地点" prop="signin_address" label-width="13%">
                        <el-input v-model="addQuery.signin_address" style="width: 300px" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="" prop="signin_lng" label-width="13%">
                        <el-row style="margin-bottom: 10px">
                            <vxe-button size="medium" content="获取签到地址经纬度" status="primary" @click="GetJWD('qiandao')"></vxe-button>
                        </el-row>
                        <el-row style="margin-bottom: 10px">
                            <el-input v-model="addQuery.signin_lng" style="width: 300px" placeholder="请选择经度" disabled></el-input>
                        </el-row>
                        <el-row>
                            <el-input v-model="addQuery.signin_lat" style="width: 300px" placeholder="请选择纬度" disabled></el-input>
                        </el-row>
                    </el-form-item>

                    <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到距离" prop="signin_distance" label-width="13%">
                        <el-select v-model="addQuery.signin_distance" placeholder="请选择" style="width: 300px">
                            <el-option v-for="item in signInMiList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>

                    <!-- <el-form-item v-if="addQuery.signin_type.indexOf('2') > -1" label="签到二维码" prop="signin_qrcode" label-width="13%">
                        <div class="from">
                            <div v-if="addQuery.signin_qrcode" class="imgbox">
                                <img :src="addQuery.signin_qrcode" alt="" class="imgs" />
                                <img src="../../assets/img/shanchu.png" mode="" class="close" @click="addQuery.signin_qrcode = ''" />
                            </div>
                        </div>
                        <el-upload v-if="!addQuery.signin_qrcode" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="onSuccessSignin_qrcode" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                            <el-button size="small" type="primary">选择</el-button>
                        </el-upload>
                    </el-form-item> -->
                </template>

                <!-- 签退 -->
                <el-form-item label="是否需要签退" label-width="13%">
                    <el-switch v-model="isSignout" active-text="是" inactive-text="否">
                    </el-switch>
                </el-form-item>

                <template v-if="isSignout">
                    <el-form-item label="签退方式" prop="signout_type" label-width="13%">
                        <el-select v-model="addQuery.signout_type" multiple placeholder="请选择" style="width: 300px">
                            <el-option v-for="item in signOutList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="签退时间" prop="signout_starttime" label-width="13%">
                        <el-date-picker v-model="signouttime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:00" @change="changeSignouttime">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退地点" prop="signout_address" label-width="13%">
                        <el-input v-model="addQuery.signout_address" style="width: 300px" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="" prop="signout_lng" label-width="13%">
                        <el-row style="margin-bottom: 10px">
                            <vxe-button size="medium" content="获取签退地址经纬度" status="primary" @click="GetJWD('qiantui')"></vxe-button>
                        </el-row>
                        <el-row style="margin-bottom: 10px">
                            <el-input v-model="addQuery.signout_lng" style="width: 300px" placeholder="请选择经度" disabled></el-input>
                        </el-row>
                        <el-row>
                            <el-input v-model="addQuery.signout_lat" style="width: 300px" placeholder="请选择纬度" disabled></el-input>
                        </el-row>
                    </el-form-item>

                    <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退距离" prop="signout_distance" label-width="13%">
                        <el-select v-model="addQuery.signout_distance" placeholder="请选择" style="width: 300px">
                            <el-option v-for="item in signOutMiList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>

                    <!-- <el-form-item v-if="addQuery.signout_type.indexOf('2') > -1" label="签退二维码" prop="signout_qrcode" label-width="13%">
                        <div class="from">
                            <div v-if="addQuery.signout_qrcode" class="imgbox">
                                <img :src="addQuery.signout_qrcode" alt="" class="imgs" />
                                <img src="../../assets/img/shanchu.png" mode="" class="close" @click="addQuery.signout_qrcode = ''" />
                            </div>
                        </div>
                        <el-upload v-if="!addQuery.signout_qrcode" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="onSuccessSignout_qrcode" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                            <el-button size="small" type="primary">选择</el-button>
                        </el-upload>
                    </el-form-item> -->
                </template>

                <el-form-item label="报名人数上限" prop="enroll_limit" label-width="13%">
                    <el-input-number v-model="addQuery.enroll_limit" style="width: 294px" placeholder="请输入报名人数"></el-input-number>
                    人
                </el-form-item>
                <!-- <el-form-item label="报名金额" label-width="13%">
          <el-input
            v-model="addQuery.enroll_fee"
            style="width: 294px"
            placeholder="请输入报名金额"
          ></el-input
          >元
        </el-form-item> -->
                <!-- <el-form-item label="赛事赞助" label-width="13%">
          <div class="formClass">
            <div
              v-for="(item, index) in addQuery.act_sponsor"
              :key="index"
              style="margin-bottom: 10px"
            >
              <el-input
                v-model="item.name"
                style="width: 294px"
                placeholder="请输入赞助商"
              ></el-input>
              <el-input
                v-model="item.content"
                style="width: 294px"
                placeholder="请输入赞助内容"
              ></el-input>
              <span @click="deletecc(index)" class="addzanzu ml">删除</span>
            </div>
          </div>
          <div class="addzanzu" @click="addzanzucc">增加新赞助</div>
        </el-form-item> -->
            </el-form>
            <el-button type="primary" @click="tijiao">提交</el-button>
        </el-card>
        <vxe-modal width="1000" ref="fabuzhe" height="800" size="small" :show-footer="false" title="请选择发布者" :show-close="true">
            <el-card>
                <el-form :inline="true">
                    <el-form-item>
                        <el-input v-model="Querycc.keyword" @input="Discountsearch" placeholder="请输入关键词"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-table :data="xiehuiArr" ref="multipleTable" @selection-change="EdithandleSelectionChange" @select="select" @select-all="selectAll" :row-key="(row) => row.user_id">
                <el-table-column type="selection" :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="org_com" label="名称"> </el-table-column>
                <el-table-column prop="pho" label="logo">
                    <template slot-scope="scope">
                        <img :src="scope.row.org_logo" min-width="70" height="70" />
                    </template>
                </el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                        {{ scope.row.types === 1 ? "商会" : "协会" }}
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="pageshow">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" :total="xiehuiTotal">
                </el-pagination>
            </div>
            <div style="margin-top: 200px">
                <el-button type="primary" @click="cclose">确认</el-button>
            </div>
        </vxe-modal>
        <div class="block-none">
            <el-upload class="avatar-uploader1" ref="upload_1" :action="
          editorImgOrVideo === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        " :on-progress="progress" :on-success="uploadSuccess" :limit="1" :before-upload="
          editorImgOrVideo === 'img' ? $beforeUploadImage : $beforeUploadVideo
        " :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" :name="editorImgOrVideo === 'img' ? 'pic' : 'video'" :shrow-file-list="false">
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </div>
        <Amap v-show="showMap" @onCancel="onCancelMap" @onAddrConfirm="AddrConfirm" />
    </div>
</template>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.4.15&key=db02839d3d4b5cd28ca4f5d631d303db &plugin=AMap.Geocoder,AMap.Autocomplete,AMap.Geolocation,AMap.PlaceSearch">
</script>
<script>
    import { area, city, province, getWzArea } from "@/api/city";
    import {
        getActiveGroup,
        addActiveGroup,
        editActiveGroup,
        delActiveGroup,
    } from "@/api/huodongfenzu";
    import { actBusinessassociationlist } from "@/api/tiezi";
    import { actMatchAdd } from "@/api/saishiguanli";
    import Amap from "../../components/Amap";
    import waves from "../../directive/waves";
    const toolbarOptions = [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],
        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"], // remove formatting button
    ];
    export default {
        name: "index",
        directives: { waves },
        components: { Amap },
        data() {
            const checkActTime = (rule, value, callback) => {
                let enroll_starttime = this.addQuery.enroll_starttime;
                let enroll_endtime = this.addQuery.enroll_endtime;
                let act_starttime = this.addQuery.act_starttime;
                let act_endtime = this.addQuery.act_endtime;

                if (enroll_starttime && enroll_endtime && act_starttime && act_endtime) {
                    enroll_starttime = new Date(
                        enroll_starttime.replace(/-/g, "/")
                    ).getTime();
                    enroll_endtime = new Date(enroll_endtime.replace(/-/g, "/")).getTime();
                    act_starttime = new Date(act_starttime.replace(/-/g, "/")).getTime();
                    act_endtime = new Date(act_endtime.replace(/-/g, "/")).getTime();

                    if (enroll_starttime >= enroll_endtime) {
                        callback(new Error("报名开始时间 必须早于 报名结束时间"));
                    } else if (enroll_endtime > act_starttime) {
                        callback(new Error("赛事开始时间 必须晚于 报名结束时间"));
                    } else if (act_starttime >= act_endtime) {
                        callback(new Error("赛事开始时间 必须早于 赛事结束时间"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };

            return {
                areaList: [],
                typeList: [{
                    label: "跑步",
                    value: "1",
                }, {
                    label: "篮球",
                    value: "2",
                }, {
                    label: "羽毛球",
                    value: "3",
                }, {
                    label: "乒乓球",
                    value: "4",
                }, {
                    label: "足球",
                    value: "5",
                }, {
                    label: "游泳",
                    value: "6",
                }, {
                    label: "篮球",
                    value: "7",
                }, {
                    label: "党建活动",
                    value: "10",
                }, {
                    label: "马拉松",
                    value: "11",
                }, {
                    label: "其他",
                    value: "8",
                }, ],
                pageshow: true,
                userform: [],
                token: sessionStorage.getItem("token"),
                spuAddresses: "",
                checkedData: {
                    // sendData: ['province_name'], // 默认选中值
                    typeOptions: {
                        lazy: true, // 开启懒加载
                        lazyLoad: this.lazyLoad,
                    },
                },
                // 限制时间选择器的控制范围
                zanzuList: [],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() <= Date.now();
                    },
                },
                endDatePickercc: this.processDatecc(),
                endDatePicker: this.processDate(),
                labelPosition: "left",
                endTime: "",
                showMap: false,
                mapShowType: "address",
                enrolltime: [],
                acttime: [],
                signintime: [],
                signouttime: [],
                addQuery: {
                    user_name: "test",
                    user_logo: "test",
                    token: sessionStorage.getItem("token"),
                    user_id: "",
                    space: "",
                    name: "",
                    pics: [],
                    introduce: "",
                    province_id: "",
                    city_id: "",
                    area_id: "",
                    town_id: "",
                    address: "",
                    act_starttime: "",
                    act_endtime: "",
                    enroll_starttime: "",
                    enroll_endtime: "",
                    enroll_limit: "999",
                    enroll_fee: 0,
                    act_sponsor: [],
                    longitude: "",
                    latitude: "",

                    act_group_ids: [],

                    signin_type: [],
                    signin_starttime: '',
                    signin_endtime: '',
                    signin_address: '',
                    signin_lng: '',
                    signin_lat: '',
                    signin_distance: 100,
                    signin_qrcode: '',

                    signout_type: [],
                    signout_starttime: '',
                    signout_endtime: '',
                    signout_address: '',
                    signout_lng: '',
                    signout_lat: '',
                    signout_distance: 100,
                    signout_qrcode: '',
                },
                rules: {
                    name: [{ required: true, message: "请输入", trigger: "blur" }],
                    space: [{ required: true, message: "请选择", trigger: "blur" }],
                    act_group_ids: [
                        { required: true, type: "array", message: "请添加", trigger: "blur" },
                    ],
                    pics: [
                        { required: true, type: "array", message: "请上传", trigger: "blur" },
                    ],
                    introduce: [{ required: true, message: "请输入", trigger: "blur" }],
                    area_id: [{ required: true, message: "请选择", trigger: "blur" }],
                    address: [{ required: true, message: "请输入", trigger: "blur" }],
                    longitude: [{ required: true, message: "请选择", trigger: "blur" }],
                    act_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    act_endtime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    enroll_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    enroll_endtime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],

                    // signin_type: [
                    //     { required: true, type: "array", message: "请选择", trigger: "blur" },
                    // ],
                    // signin_starttime: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    // signin_address: [
                    //     { required: true, message: "请输入", trigger: "blur" },
                    // ],
                    // signin_lng: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    // signin_qrcode: [
                    //     { required: true, message: "请上传", trigger: "blur" },
                    // ],

                    // signout_type: [
                    //     { required: true, type: "array", message: "请选择", trigger: "blur" },
                    // ],
                    // signout_starttime: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    // signout_address: [
                    //     { required: true, message: "请输入", trigger: "blur" },
                    // ],
                    // signout_lng: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    // signout_qrcode: [
                    //     { required: true, message: "请上传", trigger: "blur" },
                    // ],

                    enroll_limit: [{ required: true, message: "请输入", trigger: "blur" }],
                },
                query: {
                    keyword: "",
                    order_status: null,
                    shop_id: null,
                    add_time: null,
                },
                mapShow: false,
                value: "",
                cityArr: [],
                areaArrcc: [],
                Querycc: {
                    token: sessionStorage.getItem("token"),
                    keyword: "",
                    page: 1,
                    pagesize: 10,
                },
                xiehuiArr: [],
                xiehuiTotal: null,
                cur_page: 1,
                xiehuiQuery: {
                    org_com: "",
                },
                // 富文本编辑器配置
                editorOption: {
                    placeholder: "请输入内容",
                    theme: "snow", // or 'bubble'
                    modules: {
                        toolbar: {
                            container: toolbarOptions, // 工具栏
                            handlers: {
                                image: function(value) {
                                    if (value) {
                                        this.editorImgOrVideo = "img";
                                        // debugger;
                                        // 触发input框选择图片文件
                                        document.querySelector(".avatar-uploader1 input").click();
                                    } else {
                                        this.quill.format("image", false);
                                    }
                                },
                                video: (value) => {
                                    if (value) {
                                        this.editorImgOrVideo = "video";
                                        // debugger;
                                        // 触发input框选择视频文件
                                        document.querySelector(".avatar-uploader1 input").click();
                                    } else {
                                        this.quill.format("video", false);
                                    }
                                },
                            },
                        },
                    },
                },
                editorImgOrVideo: "img",

                // 赛事分组
                activeGroupForm: {
                    name: "",
                    number: "",
                    age: "",
                    sex: ""
                },
                activeGroup: [],
                sexList: [{
                    label: "男",
                    value: '男'
                }, {
                    label: "女",
                    value: '女'
                }],

                isSignin: false,
                signInList: [{
                    label: "定位签到",
                    value: '1'
                }, {
                    label: "扫码签到",
                    value: '2'
                }, {
                    label: "亮码签到",
                    value: '3'
                }],
                signInMiList: [{
                    label: "100米",
                    value: 100
                }, {
                    label: "500米",
                    value: 500
                }],

                isSignout: false,
                signOutList: [{
                    label: "定位签退",
                    value: '1'
                }, {
                    label: "扫码签退",
                    value: '2'
                }, {
                    label: "亮码签退",
                    value: '3'
                }],
                signOutMiList: [{
                    label: "100米",
                    value: 100
                }, {
                    label: "500米",
                    value: 500
                }],
            };
        },
        created() {
            this.getAreaList();
        },
        methods: {
            openjingweidu() {
                this.mapShow = true;
            },
            closeuserLogo() {
                this.addQuery.user_logo = "";
            },
            processDatecc() {
                const self = this;
                return {
                    disabledDate(time) {
                        console.log(time);
                        if (self.addQuery.enroll_starttime) {
                            // 如果开始时间不为空，则结束时间大于开始时间
                            return (
                                new Date(self.addQuery.enroll_starttime).getTime() >
                                time.getTime()
                            );
                        } else {
                            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
                        }
                    },
                };
            },
            processDate() {
                const self = this;
                return {
                    disabledDate(time) {
                        if (self.addQuery.act_starttime) {
                            // 如果开始时间不为空，则结束时间大于开始时间
                            return (
                                new Date(self.addQuery.act_starttime).getTime() > time.getTime()
                            );
                        } else {
                            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
                        }
                    },
                };
            },
            changeEnrolltime(values) {
                if (values) {
                    this.addQuery.enroll_starttime = values[0];
                    this.addQuery.enroll_endtime = values[1];
                } else {
                    this.addQuery.enroll_starttime = '';
                    this.addQuery.enroll_endtime = '';
                }
            },
            changeActtime(values) {
                if (values) {
                    this.addQuery.act_starttime = values[0];
                    this.addQuery.act_endtime = values[1];
                } else {
                    this.addQuery.act_starttime = '';
                    this.addQuery.act_endtime = '';
                }
            },
            changeSignintime(values) {
                if (values) {
                    this.addQuery.signin_starttime = values[0];
                    this.addQuery.signin_endtime = values[1];
                } else {
                    this.addQuery.signin_starttime = '';
                    this.addQuery.signin_endtime = '';
                }
            },
            onSuccessSignin_qrcode(response, file, fileList) {
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.signin_qrcode = response.pic_url;
                }
            },
            changeSignouttime(values) {
                if (values) {
                    this.addQuery.signout_starttime = values[0];
                    this.addQuery.signout_endtime = values[1];
                } else {
                    this.addQuery.signout_starttime = '';
                    this.addQuery.signout_endtime = '';
                }
            },
            onSuccessSignout_qrcode(response, file, fileList) {
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.signout_qrcode = response.pic_url;
                }
            },
            tijiao() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let signin_type = '0';
                        if (this.isSignin) {
                            signin_type = this.addQuery.signin_type.join(',');
                        }

                        let signout_type = '0';
                        if (this.isSignin) {
                            signout_type = this.addQuery.signout_type.join(',');
                        }

                        const obj = {
                            ...this.addQuery,
                            token: sessionStorage.getItem("token"),
                            pics: JSON.stringify(this.addQuery.pics),
                            act_sponsor: JSON.stringify(this.addQuery.act_sponsor),
                            act_group_ids: this.activeGroup.map((item) => parseInt(item.id)),
                            signin_type,
                            signout_type
                        };
                        actMatchAdd(obj).then(({ data: res }) => {
                            console.log("res", res);
                            if (res.result === -1) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                setTimeout(() => {
                                    window.sessionStorage.clear();
                                    this.$router.push("/login");
                                }, 1000);
                            }
                            if (res.result === 0) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                return false;
                            }
                            if (res.result === 1) {
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                    duration: "2000",
                                });
                                this.addQuery = {};
                                this.$router.push("/saishiguanli");
                            }
                        });
                    } else {}
                });
            },
            xingbieChange(item, index) {
                if (index === 0) {
                    this.typeList[0].img =
                        "https://ptumao2.5laoye.com/images/radioTrue.png";
                    this.typeList[1].img =
                        "https://ptumao2.5laoye.com/images/radioFalse.png";
                    this.addQuery.space = "室内";
                } else if (index === 1) {
                    this.typeList[0].img =
                        "https://ptumao2.5laoye.com/images/radioFalse.png";
                    this.typeList[1].img =
                        "https://ptumao2.5laoye.com/images/radioTrue.png";
                    this.addQuery.space = "室外";
                }
            },
            Discountsearch() {
                this.cur_page = 1;
                this.List();
                this.pageshow = false; // 让分页隐藏
                this.$nextTick(() => {
                    // 重新渲染分页
                    this.pageshow = true;
                });
            },
            select(selection, row) {
                if (selection.length > 1) {
                    // eslint-disable-next-line camelcase
                    const del_row = selection.shift();
                    this.$refs.multipleTable.toggleRowSelection(del_row, false);
                }
            },
            selectAll(selection) {
                if (selection.length > 1) {
                    selection.length = 1;
                }
            },
            EdithandleSelectionChange(val) {
                console.log("val", val);
                this.xiehuiQuery = val[0];
                this.addQuery.user_id = this.xiehuiQuery.user_id;
                console.log("xiehuiQuery", this.xiehuiQuery);
            },
            handleSizeChange(val) {
                this.Querycc.pagesize = val;
            },
            handleCurrentChange(val) {
                this.Querycc.page = val;
                const obj = {};
                obj.pagesize = this.Querycc.pagesize;
                obj.page = this.Querycc.page;
                obj.keyword = this.Querycc.keyword;
                obj.token = this.Querycc.sessionStorage.getItem("token");
                actBusinessassociationlist(obj).then(({ data: res }) => {
                    this.xiehuiArr = res.list;
                    this.xiehuiTotal = res.total;
                });
            },
            List() {
                actBusinessassociationlist(this.Querycc).then(({ data: res }) => {
                    console.log("rescc", res);
                    this.xiehuiArr = res.list;
                    this.xiehuiTotal = res.total;
                });
            },
            cclose() {
                this.$refs.fabuzhe.close();
            },
            openfabuzhe() {
                this.$refs.fabuzhe.open();
                this.List();
            },
            async lazyLoad(node, resolve) {
                const level = node.level;
                let result;
                let res;
                let param;
                switch (level) {
                    case 0: // 一级
                        res = await getWzArea();
                        result = res.data.data;
                        result.forEach((item) => {
                            item.value = item.code;
                            item.label = item.name;
                            item.leaf = item.code === "330300000000";
                        });
                        break;
                    case 1: // 二级
                        param = {
                            code: node.data.code,
                            pid: node.data.id,
                        };
                        res = await getWzArea(param);
                        result = res.data.data;
                        console.log(result);
                        result.forEach((item) => {
                            item.value = item.code;
                            item.label = item.name;
                            item.leaf = level >= 1;
                        });
                        break;

                    default:
                        result = [];
                        break;
                }
                resolve(result);
            },
            changList(val) {
                this.addQuery.area_id = val[0];
                this.addQuery.town_id = val[1] || "";
            },
            deletecc(index) {
                this.addQuery.act_sponsor.splice(index, 1);
            },
            addzanzucc() {
                this.addQuery.act_sponsor.push({
                    name: "",
                    content: "",
                });
            },
            closeImgs(index) {
                this.addQuery.pics.splice(index, 1);
            },
            beginDate() {
                const self = this;
                return {
                    disabledDate(time) {
                        if (self.query.end_time) {
                            // 如果结束时间不为空，则小于结束时间
                            return new Date(self.query.end_time).getTime() < time.getTime();
                        } else {
                            return time.getTime() >= Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
                        }
                    },
                };
            },
            handleAvatarSuccessLogo(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.user_logo = response.pic_url;
                    console.log(" this.addQuery.user_logo ", this.addQuery.user_logo);
                }
            },
            handleAvatarSuccess(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.pics.push({
                        name: response.pic_url,
                    });
                    console.log(" this.addQuery.pic ", this.addQuery.pic);
                }
            },
            beforeUpload(file) {
                const promise = new Promise((resolve) => {
                    this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise; // 通过返回一个promis对象解决
            },
            progress(event, file, fileList) {
                console.log("event", event, "file", file, "fileList", fileList);
                // this.addquery.font_url.push({ name: file })
            },
            // 文件数量过多时提醒
            handleExceed() {
                // this.$message({ type: 'info', message: '最多支持5个附件上传' })
            },
            uploadSuccess(res, file) {
                this.$refs.upload_1.clearFiles();
                // res为图片服务器返回的数据
                // 获取富文本组件实例
                let quill = this.$refs.myQuillEditor.quill;
                // 如果上传成功
                if (res.result === 1) {
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // 插入图片  res.info为服务器返回的图片地址
                    if (this.editorImgOrVideo === "img") {
                        quill.insertEmbed(length, "image", res.pic_url);
                        // 调整光标到最后
                        quill.setSelection(length + 1);
                    } else {
                        quill.insertEmbed(length, "video", res.video_url);
                        // 调整光标到最后
                        quill.setSelection(length + 1);
                    }

                    this.$forceUpdate();
                } else {
                    this.$message.error("图片插入失败");
                }
            },
            async getAreaList() {
                try {
                    const res = await getWzArea();
                    const result = res.data.data;
                    result.forEach((item) => {
                        item.value = item.code;
                        item.label = item.name;
                    });
                    this.areaList = result;
                } catch (error) {
                    console.log(error);
                }
            },
            GetJWD(type) {
                this.showMap = true;
                this.mapShowType = type;
            },
            onCancelMap() {
                this.showMap = false;
            },
            AddrConfirm(res) {
                console.log("onAddrConfirm", res);
                this.showMap = false;
                switch (this.mapShowType) {
                    case "address":
                        this.addQuery.longitude = res.lng;
                        this.addQuery.latitude = res.lat;
                        break;
                    case "qiandao":
                        this.addQuery.signin_lng = res.lng;
                        this.addQuery.signin_lat = res.lat;
                        break;
                    case "qiantui":
                        this.addQuery.signout_lng = res.lng;
                        this.addQuery.signout_lat = res.lat;
                        break;
                    default:
                        break;
                }
                this.addQuery.longitude = res.lng;
                this.addQuery.latitude = res.lat;
            },

            addGroup() {
                const act_id = 0;
                const activeGroupForm = this.activeGroupForm;
                if (activeGroupForm.name && activeGroupForm.number && activeGroupForm.age && activeGroupForm.sex) {
                    const title = activeGroupForm.name + ',' + activeGroupForm.number + ',' + activeGroupForm.age + ',' + activeGroupForm.sex;
                    addActiveGroup({
                        token: this.token,
                        act_id,
                        title,
                    }).then(({ data: res }) => {
                        this.activeGroupForm = {
                            name: '',
                            number: '',
                            age: '',
                            sex: ''
                        };
                        this.activeGroup.push({
                            act_id,
                            id: res.data.id,
                            title,
                            ...activeGroupForm,
                        });
                        this.addQuery.act_group_ids = this.activeGroup.map((item) =>
                            parseInt(item.id)
                        );
                    });
                }
            },
            deleteGroup(item, index) {
                delActiveGroup({
                    token: this.token,
                    id: item.id,
                }).then((res) => {
                    this.activeGroup.splice(index, 1);
                    this.addQuery.act_group_ids = this.activeGroup.map((item) =>
                        parseInt(item.id)
                    );
                });
            },
        },
    };
</script>

<style lang="less">
    .search-box {
        border: 1px solid #ccc;
        width: 100%;
    }

    .search-box-wrapper {
        width: 100%;
    }

    .amap-page-container {
        width: 500px;
        height: 500px;
        z-index: 999;
    }

    .amap-demo {
        height: 300px;
        height: 300px;
    }

    .radiobox {
        display: flex;
        flex-direction: row;
        align-items: center;

        .samnfa {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 10px;

            .imgs {
                width: 20px;
                height: 20px;
                opacity: 1;
                margin-right: 20px;
            }
        }
    }

    .el-upload-list {
        display: none;
    }

    .from {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .imgbox {
        width: 188px;
        height: 188px;
        opacity: 1;
        background: rgba(0, 0, 0, 0);
        border-radius: 5px;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;

        .imgs {
            width: 100%;
            height: 100%;
        }

        .close {
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            height: 20px;
            opacity: 1;
            background: #e54848;
            border-radius: 50%;
        }
    }

    .el-scrollbar__wrap {
        height: 200px;
    }

    .fabuzhe {
        width: 294px;
        height: 44px;
        opacity: 1;
        background: #fbfbfb;
        border-radius: 5px;
        padding-left: 12px;
        display: flex;
        justify-content: left;
    }

    .ml {
        margin-left: 10px;
    }

    .formClass {
        display: flex;
        flex-direction: column;
    }

    .addzanzu {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #3d9aff;
    }

    .body {
        display: flex;
        flex-direction: column;

        .title {
            opacity: 1;
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Heavy;
            font-weight: 800;
            text-align: left;
            color: #2e2e2e;
            letter-spacing: 0px;
            margin-bottom: 35px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .fansk {
                margin-top: 30px;
                margin-left: 32px;
            }

            .dsadf {
                color: #3d9aff;
            }
        }
    }

    .block-none {
        display: none;
    }
</style>
